
import { useUiStore } from "../stores/uiStore";

/** Object selection state for the sandbox */
export function useSelection() {
  const selectedObjectId = useUiStore((s) => s.selectedObjectId);
  const selectObject = useUiStore((s) => s.selectObject);
  const clearSelection = useUiStore((s) => s.clearSelection);

  return {
    selectedObjectId,
    selectObject,
    clearSelection,
  };
}
